<template>
    <div class="publications">
        <Title :title="title"></Title>
        <div class="row center-xs publications-line">
            <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
                <div class="row" v-if="publications">
                    <div class="col-xs-12 col-md-6" v-for="publication in publications.items" :key="publication.fields.title">
                        <Card
                                v-on:card-selection="onSelectPublication(publication)"
                                :image="getPublicationAsset(publication.fields.cardImage)"
                                :entry="publication"
                                :action="'Ver'"
                                :title-height="'6em'"
                                :image-height="'14em'"
                        ></Card>
                    </div>
                </div>
                <div class="row" v-if="more">
                    <div class="col-xs-12 publications-know-more">
                        <button v-on:click="publicationList()">Mais Publicações</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Title from "../generic/Title";
    import Card from "../cards/Card";

    export default {
        name: "Publications",
        components: {Card, Title},
        props: ['publications', 'more', 'title'],
        methods: {
            getPublicationAsset(field) {
                if (field) {
                    return this.publications.includes.Asset.find(asset => asset.sys.id === field.sys.id);
                } else {
                    return null;
                }
            },
            publicationList() {
                this.$router.push(`/publications`).catch(() => {});
            },
            onSelectPublication(publication) {
                window.open(publication.fields.link, '_blank');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";

    .publications {
        margin-top: 3em;
        margin-bottom: 3em;
        background-color: $bgcolor;
        padding-bottom: 2em;
    }

    .publications-line {
        margin-top: 3em;
        .publications-card {
            margin: 0.4em;
            height: 20em;
            background-color: $bgcolor;
        }
    }

    .publications-know-more {
        margin-top: 3.5em;
        button {
            height: 3.5em;
            border: 0;
            width: 100%;
            background: $primary;
            color: $bgcolor-grey;
            text-transform: uppercase;
            font-size: x-small;
            letter-spacing: 0.1em;
            font-weight: 600;

            &:hover {
                background: $bgcolor-grey;
                color: $primary;
            }
        }

    }
</style>
